import api from './api';

class SettingsService {
  async getAppointmentSettings() {
    try {
      const response = await api.get('/settings/appointment');
      console.log('Get Settings API Response:', response);
      console.log('Response data:', response.data);
      
      // Check if response has the new format { success, data } or old format (direct data)
      if (response.data.success !== undefined) {
        return {
          success: response.data.success,
          data: response.data.data
        };
      } else {
        // Old format - data is returned directly
        return {
          success: true,
          data: response.data
        };
      }
    } catch (error) {
      console.error('Error fetching appointment settings:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch appointment settings'
      };
    }
  }

  async updateAppointmentSettings(settings) {
    try {
      const response = await api.put('/settings/appointment', settings);
      console.log('Settings API Response:', response);
      console.log('Response data:', response.data);
      
      // Check if response has the new format { success, data } or old format (direct data)
      if (response.data.success !== undefined) {
        return {
          success: response.data.success,
          data: response.data.data
        };
      } else {
        // Old format - data is returned directly
        return {
          success: true,
          data: response.data
        };
      }
    } catch (error) {
      console.error('Error updating appointment settings:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to update appointment settings'
      };
    }
  }

  async getQueueSettings() {
    try {
      const response = await api.get('/settings/queue');
      console.log('Get Queue Settings API Response:', response);
      
      if (response.data.success !== undefined) {
        return {
          success: response.data.success,
          data: response.data.data
        };
      } else {
        return {
          success: true,
          data: response.data
        };
      }
    } catch (error) {
      console.error('Error fetching queue settings:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch queue settings'
      };
    }
  }

  async updateQueueSettings(settings) {
    try {
      const response = await api.put('/settings/queue', settings);
      console.log('Update Queue Settings API Response:', response);
      
      if (response.data.success !== undefined) {
        return {
          success: response.data.success,
          data: response.data.data
        };
      } else {
        return {
          success: true,
          data: response.data
        };
      }
    } catch (error) {
      console.error('Error updating queue settings:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to update queue settings'
      };
    }
  }

  async getBookingLimits() {
    try {
      const response = await api.get('/settings/booking-limits');
      console.log('Booking Limits API Response:', response);
      
      return {
        success: response.data.success,
        data: response.data.data
      };
    } catch (error) {
      console.error('Error fetching booking limits:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch booking limits'
      };
    }
  }

  async getVoiceCallSettings() {
    try {
      const response = await api.get('/settings/voice-call');
      console.log('Get Voice Call Settings API Response:', response);
      
      return {
        success: response.success,
        data: response.data,
        defaultSystemPrompt: response.defaultSystemPrompt
      };
    } catch (error) {
      console.error('Error fetching voice call settings:', error);
      return {
        success: false,
        error: error.message || 'Failed to fetch voice call settings'
      };
    }
  }

  async updateVoiceCallSettings(settings) {
    try {
      const response = await api.put('/settings/voice-call', settings);
      console.log('Update Voice Call Settings API Response:', response);
      
      return {
        success: response.success,
        data: response.data,
        message: response.message,
        defaultSystemPrompt: response.defaultSystemPrompt,
        syncError: response.syncError
      };
    } catch (error) {
      console.error('Error updating voice call settings:', error);
      return {
        success: false,
        error: error.message || 'Failed to update voice call settings'
      };
    }
  }

  async getVoiceOptions() {
    try {
      const response = await api.get('/settings/voice-call/voices');
      return {
        success: response.success,
        data: response.data,
        configured: response.configured
      };
    } catch (error) {
      console.error('Error fetching voice options:', error);
      return {
        success: false,
        error: error.message || 'Failed to fetch voice options'
      };
    }
  }

  async getPromptVariables() {
    try {
      const response = await api.get('/settings/voice-call/variables');
      return {
        success: response.success,
        data: response.data
      };
    } catch (error) {
      console.error('Error fetching prompt variables:', error);
      return {
        success: false,
        error: error.message || 'Failed to fetch prompt variables'
      };
    }
  }

  async getVoiceTools() {
    try {
      const response = await api.get('/settings/voice-call/tools');
      return {
        success: response.success,
        data: response.data
      };
    } catch (error) {
      console.error('Error fetching voice tools:', error);
      return {
        success: false,
        error: error.message || 'Failed to fetch voice tools'
      };
    }
  }

  async placeVoiceTestCall({ patientId, phoneNumber, settings }) {
    try {
      const response = await api.post('/settings/voice-call/test-call', {
        patientId,
        phoneNumber,
        settings
      });
      return {
        success: response.success,
        data: response.data,
        message: response.message
      };
    } catch (error) {
      console.error('Error placing test call:', error);
      return {
        success: false,
        error: error.message || 'Failed to place test call'
      };
    }
  }
}

export default new SettingsService();
